<template>
    <div v-if="message.messageType == 'unsupported'">
        <!-- received message  -->
        <div v-if="message.senderType == 'contact'" class="d-flex align-end justify-start mx-2 my-2">
            <div class="small-chat-img mr-2">
                <img src="https://t3.ftcdn.net/jpg/03/53/11/00/360_F_353110097_nbpmfn9iHlxef4EDIhXB1tdTD0lcWhG9.jpg"
                    alt="user" />
            </div>
            <div class="chat-recv-msg bg-white">
                <div class="unsupported-message">
                    <v-icon small color="grey darken-1">mdi-alert-circle-outline</v-icon>
                    <span class="ml-1">Unsupported message type</span>
                </div>
                <div class="time ta-r">{{ formattedTime(message.sentAt) }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UnsupportedMessage',
    props: ["message", "formattedTime"],
};
</script>

<style scoped>
.bg-white {
    background-color: white;
}

.chat-recv-msg {
    font-size: 0.8rem;
    padding: 0.5rem;
    border-radius: 8px;
    max-width: 60%;
}

.small-chat-img {
    width: 2rem;
    height: 2rem;
    overflow: hidden;
    border-radius: 50%;
    position: relative;
}

.small-chat-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    position: absolute;
    top: 0;
    left: 0;
}

.ta-r {
    text-align: right;
}

.time {
    font-size: 0.6rem;
}

.unsupported-message {
    display: flex;
    align-items: center;
    color: #757575;
    font-style: italic;
}
</style>